import { intersection } from 'lodash-es';
export const hasPermissionsAnd = (user_permission_roles, required_permission_roles) => {
    return (intersection(user_permission_roles, required_permission_roles).length === required_permission_roles.length);
};
export const hasPermissionsOr = (user_permission_roles, required_permission_roles) => {
    return intersection(user_permission_roles, required_permission_roles).length > 0;
};
//# sourceMappingURL=helpers.js.map